// full page and cross thefoos and fooaccounts experiment flags
export const EXPERIMENT_PAGE_DESIGN_FLAGS = [
  'homepageRedesign',
  'premiumOndemandClasses',
  'premiumVsStandardDesign',
  'premiumOndemandClassesTrials',
];

export const CTA_LABEL_FOR_DIFFERENT_TRIAL_LENGTHS = 'Start Your Free Trial';
export const EXPERIMENT__DIFFERENT_PLAN_TRIALS = 'differentPlanTrials';
export const EXPERIMENT__UPDATED_TRIAL_LABELS = 'updatedTrialLabels';



// WEBPACK FOOTER //
// ./src/experiments/constants.js